const CHANGE_COLOR_TEXT = "productDetailsSummaryChangeColorText";
const COLOR_PANEL_TITLE = "productDetailsSummaryColorPanelTitle";
const PRICE_FROM = "fromText";
const PRICE_FOR_ONLY = "productDetailsSummaryPriceForOnly";
const POINTS_TEXT = "pointsText";
const FIRST_INSTALLMENT_TEXT = "firstInstallmentText";
const PER_MONTH = "perMonthText";
const FOR_X = "productDetailsSummaryForX";
const INSTALLMENTS_TOTAL_TITLE = "productDetailsInstallmentsTotalTitle";
const SUMMARY_TOTAL_TITLE = "productDetailsSummaryTotalTitle";
const SUMMARY_TOTAL_WITH_INSTALLMENTS_TITLE =
	"productDetailsSummaryTotalWithInstallmentsTitle";
const CHANGE_PURCHASE_MODE_TEXT = "productDetailsSummaryChangePurchaseModeText";
const PURCHASE_MODE_PANEL_TITLE = "productDetailsSummaryPurchaseModePanelTitle";
const DISCOUNT_DESCRIPTION_TEXT = "productDetailsSummaryDefaultDiscountText";
const DISCOUNT_FREE_TEXT = "productDetailsDiscountFreeText";
const DISCOUNT_PREFIX = "productDetailsPPDiscountPrefix";
const FREE_DELIVERY_TITLE = "productDetailsFreeDeliveryTitle";
const FREE_DELIVERY_VALUE = "productDetailsFreeDeliveryValue";
const INVALID_COLOR_NAME = "productDetailsInvalidColorName";

export const summaryResourceKeys = {
	CHANGE_COLOR_TEXT,
	COLOR_PANEL_TITLE,
	PRICE_FROM,
	POINTS_TEXT,
	PRICE_FOR_ONLY,
	FIRST_INSTALLMENT_TEXT,
	PER_MONTH,
	FOR_X,
	INSTALLMENTS_TOTAL_TITLE,
	SUMMARY_TOTAL_TITLE,
	SUMMARY_TOTAL_WITH_INSTALLMENTS_TITLE,
	CHANGE_PURCHASE_MODE_TEXT,
	PURCHASE_MODE_PANEL_TITLE,
	DISCOUNT_DESCRIPTION_TEXT,
	DISCOUNT_FREE_TEXT,
	DISCOUNT_PREFIX,
	FREE_DELIVERY_TITLE,
	FREE_DELIVERY_VALUE,
	INVALID_COLOR_NAME
};
